import React, { useEffect, useState } from 'react';
import moment from 'moment';
import DeleteModal from '../../utils/deleteModal/deleteModal';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import TemplatePrev from './TemplatePrev';
import AddTemplate from './AddTemplate';
import services from '../../services';
import { FiEye, FiEdit2, FiTrash2, FiPlus, FiFileText } from 'react-icons/fi';
import PageHeader from '../../common/PageHeader';
import TablePagination from '../../common/TablePagination';
import { styles } from './TemplateTable.styles';
import '../UserManage/User.css';

const TemplateTable = () => {
    const [templateData, setTemplateData] = useState([]);
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [selectDeleteId, setSelectDeleteId] = useState('');
    const [selectedPrevData, setSelectedPrevData] = useState('');
    const [showModalPrev, setShowModalPrev] = useState(false);
    const [templateAddStatus, setTemplateAddStatus] = useState(false);
    const [EDITVALUE, setEDITVALUE] = useState('');
    const [editId, setEditId] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 8;
    const navigate = useNavigate();
    const handleStatusToggle = async (item) => {
        try {
            await services.template.UPDATE_TEMPLATE(item?.id, { status: !item?.status });
            toast.success('Update Successfully');
            GET_ALL_TEMPLATE();
        } catch (e) {
            console.error(e);
        }
    };

    const handleEdit = (item) => {
        setTemplateAddStatus(true);
        setEDITVALUE(item);
        setEditId(item?.id);
    };
    const handlePrev = (data) => {
        setShowModalPrev(true);
        setSelectedPrevData(data);
    };

    const handleDelete = async () => {
        try {
            await services.template.DELETE_TEMPLATE(selectDeleteId);
            toast.success('Template Delete Successfully');
            GET_ALL_TEMPLATE();
        } catch (e) {
            console.error(e);
        }
    };

    const handleConfirm = () => {
        setShowModalDelete(false);
        handleDelete();
    };

    useEffect(() => {
        GET_ALL_TEMPLATE();
    }, []);
    function linkifyHTML(input) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = input;

        function linkifyNode(node) {
            if (node.nodeType === Node.TEXT_NODE) {
                let replaced = node.nodeValue;

                replaced = replaced.replace(
                    /\b(https?:\/\/[^\s<]+|www\.[^\s<]+)/g,
                    (match) => {
                        const href = match.startsWith('http') ? match : `http://${match}`;
                        return `<a href="${href}" target="_blank">${match}</a>`;
                    }
                );

                replaced = replaced.replace(
                    /\b([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\b/g,
                    '<a href="mailto:$1">$1</a>'
                );

                replaced = replaced.replace(
                    /(\+?\d[\d\s\-]{7,}\d)/g,
                    '<a href="tel:$1">$1</a>'
                );

                if (replaced !== node.nodeValue) {
                    const span = document.createElement('span');
                    span.innerHTML = replaced;
                    node.parentNode.replaceChild(span, node);
                }
            } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'A' && node.tagName !== 'IMG') {
                node.childNodes.forEach(linkifyNode);
            }
        }

        tempDiv.childNodes.forEach(linkifyNode);
        return tempDiv.innerHTML;
    }

    const GET_ALL_TEMPLATE = async () => {
        try {
            const response = await services.template.GET_ALL_TEMPLATE();
            setTemplateData(
                response &&
                response?.templates?.length > 0 &&
                response?.templates?.map((item) => ({
                    templateName: item?.name,
                    templateData: linkifyHTML(item?.body || ''),
                    status: item?.status,
                    id: item?.id,
                    createdAt: item?.createdAt,
                    subject: item?.subject,
                })),
            );
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <div style={styles.pageWrapper}>
            {/* ── Page Header ── */}
            <PageHeader
                onBack={() => navigate('/app')}
                icon={<FiFileText size={17} color="#fff" />}
                title="Email Templates"
                count={Array.isArray(templateData) ? templateData.length : 0}
                rightContent={
                    <button
                        style={styles.btnAddTemplate}
                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#1a6b2e'; }}
                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#1a7d3e'; }}
                        onClick={() => {
                            setTemplateAddStatus(true);
                            setEDITVALUE('');
                            setEditId('');
                        }}
                    >
                        <FiPlus size={15} />
                        Add Template
                    </button>
                }
            />

            {/* ── Table Card ── */}
            <div style={styles.tableCard}>
                <div style={styles.tableScroll}>
                    <table style={styles.table}>
                        <thead>
                            <tr style={styles.theadRow}>
                                <th style={{ ...styles.thNoSort, width: '52px' }}>S.No</th>
                                <th style={{ ...styles.thNoSort, width: '200px' }}>Template Name</th>
                                <th style={{ ...styles.thNoSort }}>Subject</th>
                                <th style={{ ...styles.thNoSort, width: '140px' }}>Create Date</th>
                                <th style={{ ...styles.thNoSort, width: '100px', textAlign: 'center' }}>Status</th>
                                <th style={{ ...styles.thNoSort, width: '120px', textAlign: 'center' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {templateData && templateData?.length > 0 ? (
                                templateData
                                    .slice((currentPage - 1) * pageSize, currentPage * pageSize)
                                    .map((item, index) => (
                                        <tr
                                            key={item.id}
                                            style={styles.row}
                                            onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#f6fdf8'; }}
                                            onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#fff'; }}
                                        >
                                            <td style={styles.indexCell}>
                                                {(currentPage - 1) * pageSize + index + 1}
                                            </td>

                                            <td style={styles.td}>
                                                <div style={styles.nameCell}>
                                                    <div style={styles.avatar}>
                                                        {(item?.templateName || '?').charAt(0).toUpperCase()}
                                                    </div>
                                                    <span style={styles.nameText}>{item?.templateName}</span>
                                                </div>
                                            </td>

                                            <td style={styles.subjectCell}>
                                                <span style={styles.subjectText} title={item?.subject}>
                                                    {item?.subject || '—'}
                                                </span>
                                            </td>

                                            <td style={styles.td}>
                                                <span style={styles.dateBadge}>
                                                    {moment(item?.createdAt).format('DD MMM YYYY')}
                                                </span>
                                            </td>

                                            <td style={styles.statusCell}>
                                                <div className="form-check form-switch" style={{ display: 'flex', justifyContent: 'center', margin: 0 }}>
                                                    <input
                                                        className="form-check-input"
                                                        style={{ height: '20px', width: '36px', cursor: 'pointer', accentColor: '#1a7d3e' }}
                                                        type="checkbox"
                                                        checked={item.status}
                                                        onChange={() => handleStatusToggle(item)}
                                                    />
                                                </div>
                                            </td>

                                            <td style={styles.actionCell}>
                                                <div style={styles.actionGroup}>
                                                    <button
                                                        style={styles.btnView}
                                                        title="Preview"
                                                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#f3f4f6'; e.currentTarget.style.color = '#374151'; }}
                                                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#f9fafb'; e.currentTarget.style.color = '#6b7280'; }}
                                                        onClick={() => handlePrev(item)}
                                                    >
                                                        <FiEye size={14} />
                                                    </button>
                                                    <button
                                                        style={styles.btnEdit}
                                                        title="Edit"
                                                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#dcfce7'; }}
                                                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#f0fdf4'; }}
                                                        onClick={() => handleEdit(item)}
                                                    >
                                                        <FiEdit2 size={13} />
                                                    </button>
                                                    <button
                                                        style={styles.btnDelete}
                                                        title="Delete"
                                                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#fee2e2'; }}
                                                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#fff5f5'; }}
                                                        onClick={() => {
                                                            setShowModalDelete(true);
                                                            setSelectDeleteId(item.id);
                                                        }}
                                                    >
                                                        <FiTrash2 size={13} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                            ) : (
                                <tr>
                                    <td colSpan={6}>
                                        <div style={styles.emptyState}>
                                            <FiFileText size={40} color="#d1d5db" />
                                            <p style={styles.emptyText}>No templates added yet</p>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* ── Pagination ── */}
            {Array.isArray(templateData) && templateData.length > pageSize && (
                <div style={{ marginTop: '20px' }}>
                    <TablePagination
                        currentPage={currentPage}
                        totalPages={Math.ceil(templateData.length / pageSize)}
                        onPageChange={setCurrentPage}
                    />
                </div>
            )}

            {showModalDelete && (
                <DeleteModal
                    handleCloseModal={() => setShowModalDelete(false)}
                    handleConfirm={handleConfirm}
                    showModal={showModalDelete}
                    confirmButtonName={'Delete'}
                />
            )}
            {showModalPrev && (
                <TemplatePrev
                    selectedPrevData={selectedPrevData}
                    showModal={showModalPrev}
                    handleClose={() => setShowModalPrev(false)}
                    handleEditorChange={() => { }}
                />
            )}
            {templateAddStatus && (
                <AddTemplate
                    showModal={templateAddStatus}
                    handleClose={() => setTemplateAddStatus(false)}
                    GET_ALL_TEMPLATE={GET_ALL_TEMPLATE}
                    EDITVALUE={EDITVALUE}
                    editId={editId}
                />
            )}
        </div>
    );
};

export default TemplateTable;
